import {Roles} from "../admin_area/services/permissionManager";

const nav = {
    items: [
        {
            name: 'General Conditions of Sale',
            url: 'Gcs',
            icon: 'icon-notebook',
            hiddenFor: ['gcs_checked']
        },
        {
            name: 'Dashboard',
            url: 'Dashboard',
            icon: 'icon-notebook',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },
        {
            name: 'Customers',
            url: 'Customers',
            icon: 'icon-people',
            hiddenFor: ['gcs_unchecked','no_active_account']
        },
        {
            name: 'Manage devices',
            url: 'Manage devices',
            icon: 'icon-screen-smartphone',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },

        {
            name: 'Orders',
            url: 'Orders',
            icon: 'icon-bag',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
            children: [
              {
                name: 'Orders',
                url: 'Orders',
                icon: 'icon-bag',
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
              },
              {
                name: 'Order Requests',
                url: 'Order Requests',
                icon: 'icon-basket-loaded',
                allowedFor: ['mkt_it'],
                hiddenFor: ['unknown','gcs_unchecked','no_active_account', 'no_prepayment']
              },
              // {
              //   name: 'Rebates',
              //   url: 'Rebates',
              //   icon: 'icon-basket-loaded',
              //   hiddenFor: ['unknown','gcs_unchecked','no_active_account','has_distributor']
              // },
          ]
        },
        {
            name: 'Updates',
            icon: 'icon-cloud-download',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
            children : [
                {
                    name: 'Update history',
                    url: 'Update history',
                    // icon: 'icon-cloud-download',
                },
                {
                    name: 'Scheduled updates',
                    url: 'Scheduled updates',
                }
            ]
        },
        {
            name: 'Manage dealers',
            icon: 'icon-organization',
            allowedFor: ['distributor'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
            children : [
                {
                    name: 'Accounts',
                    url: 'Distributor Accounts'
                },
                {
                    name: 'Order history',
                    url: 'Distributor Orders'
                },
                // {
                //     name: 'PayBox transactions',
                //     url: 'Distributor Transactions'
                // }
            ]
        },
    ],
    side_items: [
        // {
        //     name: 'QR code invitation',
        //     url: 'QRCodeInvitation',
        //     icon: 'icon-user-follow',
        //     hiddenFor: ['gcs_unchecked','no_active_account']
        // },
        // {
        //     name: 'Smart control wallet',
        //     url: 'Smart control wallet',
        //     icon: 'icon-folder',
        //     allowedFor: ['mkt_it'],
        //     hiddenFor: ['unknown','gcs_unchecked','no_active_account','abroad','prepayment']
        // },
        // {
        //     name: 'Licenses',
        //     url: 'Licenses',
        //     icon: 'icon-folder',
        //     notification: ['expiring_licenses', 'expiring_anydesk_licenses', 'expiring_clink_licenses', 'expiring_stockforshop_licenses', 'expiring_ats3_licenses', 'expiring_xtools_licenses'],
        //     allowedFor: ['mkt_it', 'abroad'],
        //     hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        // },
        {
            name: 'DGFE Management',
            url: 'DGFE Initializations',
            icon: 'icon-disc',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },
        {
            name: 'Account demo XStore',
            url: 'Account demo',
            icon: 'icon-disc',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account','not_has_demo']
        },
        // {
        //     name: 'PayBox activations',
        //     url: 'PayBoxActivationsContainer',
        //     icon: 'icon-disc',
        //     allowedFor: ['mkt_it', 'mkt_de', 'mkt_ch'],
        //     hiddenFor: ['unknown','gcs_unchecked','no_active_account'],
        // },
        // {
        //     name: 'Download area',
        //     url: 'Download area',
        //     icon: 'icon-folder',
        //     allowedFor: ['mkt_it'],
        //     hiddenFor: ['unknown','gcs_unchecked','no_active_account','com_lock']
        // },
        {
            name: 'Settings',
            url: 'Settings',
            icon: 'icon-settings',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },
        {
            name: 'Labels management',
            url: 'Labels management',
            icon: 'fas fa-tags',
            allowedFor: ['mkt_it'],
            hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },
        {
          name: 'Users',
          url: 'Users',
          icon: 'icon-people',
          allowedFor: ['mkt_it'],
          hiddenFor: ['unknown','gcs_unchecked','no_active_account']
        },
        {
            name: 'Company data',
            url: 'Company',
            icon: 'fas fa-building',
            hiddenFor: ['no_active_account']
        },
    ]
}

export default nav;
